import React from 'react';

const SatelliteImage = ({ lat, lng, ...rest }) => {
  return (
    <img
      src={satelliteImageURL({ lat, lng })}
      alt="Your lawn from space"
      {...rest}
    />
  );
};

export default SatelliteImage;

export const satelliteImageURL = ({ lat, lng }) => {
  return googleStaticImageURL({ lat, lng });
};

function googleStaticImageURL({ lat, lng }) {
  const base = 'https://maps.googleapis.com/maps/api/staticmap';
  const params = new URLSearchParams({
    key: window.env.GOOGLE_MAPS_API_KEY,
    center: `${lat},${lng}`,
    zoom: 20,
    maptype: 'satellite',
    scale: 2,
    size: '500x500',
  });

  return `${base}?${params}`;
}
